<template>
    <transition name="modal">
        <div :class="useModalDialogsV2 ? 'modal-maskV2' : 'modal-mask'" v-if="isVisible">
            <div class="modal-wrapper">
                <div :class="useModalDialogsV2 ? 'modal-containerV2' : 'modal-container'">
                    <div :class="useModalDialogsV2 ? 'modal-headerV2' : 'modal-header'">
                        <slot name="header">
                            Information
                        </slot>
                        <img v-if="useModalDialogsV2" src="../../../public/icons/workflow/close.svg" class="theme-svg" id="close" @click="$emit('close')" />
                    </div>

                    <div :class="useModalDialogsV2 ? 'modal-bodyV2' : 'modal-body'">
                        <template v-if="!useModalDialogsV2">
                            <slot name="icon">
                                default icon
                            </slot>
                        </template>
                        <slot name="body">
                            default body
                        </slot>
                    </div>

                    <div :class="useModalDialogsV2 ? 'modal-footerV2' : 'modal-footer'">
                        <slot name="footer">
                            default footer
                            <button class="modal-default-button" @click="$emit('close')">
                                OK
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-facing-decorator';

    @Component
    export default class Confirm extends Vue {
        public isVisible = false;
        get useModalDialogsV2(): boolean { return this.$store.state.security.ModalDialogsFeatureFlagValue; }

        mounted() {
            // Assign isVisible true on mounted as part of vue3 migration
            // Transition root https://v3-migration.vuejs.org/breaking-changes/transition-as-root.html
            this.isVisible = true;
        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-maskV2 {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #242d48b3;
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        max-width: 35%;
        margin: 0 auto;
        transition: all 0.3s ease;
    }

    .modal-containerV2 {
        max-width: 35%;
        margin: 0 auto;
        transition: all 0.3s ease;
        background-color: var(--background-primary);
        border-radius: 4px;
    }

    #close {
        cursor: pointer;
    }

    .modal-header {
        padding: 6px;
        padding-left: 12px;
    }

    .modal-headerV2 {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        border-bottom: none;
        font-size: 18px;
        line-height: 21px;
        font-weight: 600;
    }

    .modal-body {
        text-align: center;
        margin: 12px;
    }

    .modal-bodyV2 {
        margin: 0;
        padding: 16px;
        text-align: left;
    }

    .modal-footer {
        justify-content: center;
        border: none;
    }

    .modal-footerV2 {
        display: flex;
        justify-content: end;
        margin: 0;
        padding: 16px;
        border-top: 1px solid var(--anaplan-border);
        gap: 16px;
    }

    .modal-enter-from {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

        .modal-enter-from .modal-container,
        .modal-leave-active .modal-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }
</style>
